import { Download } from "lucide-react";
import { API } from "@/lib/api";
import { LEAD_STATUSES } from "@/lib/constants";

const FIELD_LABELS = [
  ["Unternehmen", "company"],
  ["Rolle", "role"],
  ["E-Mail", "email"],
  ["Telefon", "phone"],
  ["Website", "website"],
  ["Standorttyp", "location_type"],
  ["Ort/Region", "city_region"],
  ["Fläche", "available_area"],
  ["Raumhöhe", "ceiling_height"],
  ["Zustand", "current_status"],
  ["System", "product_interest"],
  ["Zielgruppe", "target_group"],
  ["Zeitplan", "timeline"],
  ["Quelle", "source_page"],
  ["Art", "kind"],
];

function formatValue(key, raw) {
  if (!raw) return "—";
  if (key === "available_area") return `${raw} m²`;
  return raw;
}

export default function LeadDetailDrawer({ lead, token, onClose, onStatusChange }) {
  if (!lead) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <aside
        className="absolute right-0 top-0 h-full w-full md:w-[640px] bg-[#0B0F10] border-l border-[rgba(255,255,255,0.12)] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        data-testid="lead-detail"
      >
        <div className="p-6 border-b border-[rgba(255,255,255,0.08)] flex items-center justify-between sticky top-0 bg-[#0B0F10]">
          <div>
            <div className="overline">Lead</div>
            <h3 className="font-display text-xl mt-1">
              {lead.first_name} {lead.last_name}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-[#AEB7B7] hover:text-white"
            data-testid="close-detail"
            type="button"
          >
            ✕
          </button>
        </div>
        <div className="p-6 space-y-6">
          <div>
            <label className="field-label">Status ändern</label>
            <select
              value={lead.lead_status}
              onChange={(e) => onStatusChange(lead.id, e.target.value)}
              className="field"
              data-testid="detail-status-select"
            >
              {LEAD_STATUSES.map((s) => (
                <option key={s.value} value={s.value}>
                  {s.label}
                </option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-2 gap-4 text-sm">
            {FIELD_LABELS.map(([label, key]) => (
              <div key={key} className="border-b border-[rgba(255,255,255,0.08)] pb-2">
                <div className="overline">{label}</div>
                <div className="text-white mt-1 break-words">
                  {formatValue(key, lead[key])}
                </div>
              </div>
            ))}
          </div>

          {lead.message && (
            <div>
              <div className="overline mb-2">Nachricht</div>
              <p className="text-[#AEB7B7] leading-relaxed whitespace-pre-wrap">
                {lead.message}
              </p>
            </div>
          )}

          {lead.files && lead.files.length > 0 && (
            <div>
              <div className="overline mb-3">Dateien</div>
              <ul className="space-y-2">
                {lead.files.map((f) => (
                  <li
                    key={f.id}
                    className="flex items-center justify-between border border-[rgba(255,255,255,0.12)] px-3 py-2"
                  >
                    <div className="text-sm">
                      <div className="text-white">{f.original_filename}</div>
                      <div className="text-xs text-[#AEB7B7]">
                        {Math.round(f.size / 1024)} KB · {f.content_type}
                      </div>
                    </div>
                    <a
                      href={`${API}/admin/files/${f.id}?auth=${token}`}
                      target="_blank"
                      rel="noreferrer"
                      className="text-[#18E096] hover:text-white inline-flex items-center gap-1 text-xs uppercase tracking-widest"
                      data-testid={`download-${f.id}`}
                    >
                      <Download size={14} strokeWidth={1.5} /> Öffnen
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </aside>
    </div>
  );
}
